import { render, staticRenderFns } from "./NewsDetailModal.vue?vue&type=template&id=6ed55da6&scoped=true&"
import script from "./NewsDetailModal.vue?vue&type=script&lang=js&"
export * from "./NewsDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed55da6",
  null
  
)

export default component.exports